import { CheckCircle, CalendarClock, Truck, Wrench, AlertTriangle, Package, ArrowUpRight } from "lucide-react";
import { useI18n } from "../i18n/I18nProvider";

/**
 * Unified status pill for materials / machines / inventory.
 * Each status maps to a color tint + icon for instant visual recognition
 * across all resource types. Pure UX layer — backend status keys unchanged.
 */
const MAP = {
  // ---- Machines ----
  tillganglig: { color: "moss",  Icon: CheckCircle,    key: "status.machine.available" },
  bokad:       { color: "clay",  Icon: CalendarClock,  key: "status.machine.booked" },
  utlamnad:    { color: "clay",  Icon: Truck,          key: "status.machine.inUse" },
  service:     { color: "ink",   Icon: Wrench,         key: "status.machine.service" },
  trasig:      { color: "brick", Icon: AlertTriangle,  key: "status.machine.broken" },
  // ---- Inventory ----
  ledig:       { color: "moss",  Icon: CheckCircle,    key: "status.inv.available" },
  ute:         { color: "clay",  Icon: ArrowUpRight,   key: "status.inv.checkedOut" },
  // inventory "trasig" reuses the machine mapping above
  // ---- Materials (listings) ----
  available:   { color: "moss",  Icon: Package,        key: "status.mat.available" },
  reserved:    { color: "clay",  Icon: CalendarClock,  key: "status.mat.reserved" },
  completed:   { color: "ink",   Icon: CheckCircle,    key: "status.mat.completed" },
};

const COLORS = {
  moss:  "var(--moss)",
  clay:  "var(--clay)",
  ink:   "var(--ink)",
  brick: "var(--brick)",
};

export default function StatusBadge({ status, size = "md" }) {
  const { t } = useI18n();
  const cfg = MAP[status];
  if (!cfg) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider border border-[var(--ink-200)] bg-[var(--surface-alt)] text-[var(--ink-500)]">
        {status || "?"}
      </span>
    );
  }
  const tint = COLORS[cfg.color] || COLORS.ink;
  const iconSize = size === "lg" ? 12 : 10;
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider"
      style={{ background: tint, color: "var(--bone)" }}
      data-testid={`status-badge-${status}`}
    >
      <cfg.Icon size={iconSize} />
      {t(cfg.key)}
    </span>
  );
}
